// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__QjiTA","total":"AdvancePaymentDetails_total__QKvZW","edit":"AdvancePaymentDetails_edit__bsjXv"};